<div class="card mb-3">
  <div #tgt id="filterBody" class="card-body">
    <div class="row row-cols-lg-auto align-items-end">
      <div *ngIf="currentView !== '' && currentView != null" class="col-12">
        <label for="currentView" class="form-label">Current view:</label>
        <select id="currentView" [(ngModel)]="currentView" class="form-select w-auto mb-3">
          <option *ngFor="let view of currentViews" value="{{view.SuccessStoryFilterID}}">{{view.SuccessStoryFilter}}</option>
        </select>
      </div>
      <div *ngIf="cgicCode !== '' && cgicCode != null" class="col-12">
        <label for="fieldDivisions" class="form-label">Filter by field division:</label>
        <select id="fieldDivisions" [(ngModel)]="cgicCode" class="form-select w-auto mb-3">
          <option value="all">All field divisions</option>
          <option *ngFor="let fieldDiv of fieldDivisions$ | async" value="{{fieldDiv.ENESS_REF_NIBINCGICCodes.OrganizationCode}}">{{fieldDiv.FieldDivisionName}}</option>
        </select>
      </div>
    </div>
    <button type="button" class="btn btn-success" (click)="applyFilters()">Apply filters</button>
  </div>
</div>
